import { RiveFile } from '@rive-app/react-canvas-lite'
import rivReward from './reward.riv'

const riveFileReward = new RiveFile({
  src: rivReward,
})

export const loadingRewardRive = riveFileReward.init().then(() => {
  riveFileReward.getInstance() // prevent from being cleaned up
  return riveFileReward
})
